/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-04-09 15:19:24
 *
 *******************************************************/
import React from 'react';
import { URL } from 'src/constants/links';
import { Link } from '@shopify/polaris';

export const SYNC_PROCESS_STATUSES = [
  {
    value: 'init',
    label: 'AdminHTML.Sync.Constants.syncProcessStatus1_Label'
  },
  { value: 'running', label: 'AdminHTML.Sync.Constants.syncProcessStatus2_Label' },
  { value: 'error', label: 'AdminHTML.Sync.Constants.syncProcessStatus3_Label' },
  { value: 'skipped', label: 'AdminHTML.Sync.Constants.syncProcessStatus4_Label' },
  { value: 'wait-retry', label: 'AdminHTML.Sync.Constants.syncProcessStatus5_Label' },
  { value: 'done', label: 'AdminHTML.Sync.Constants.syncProcessStatus6_Label' }
];

export const syncStep = [
  { key: 'SyncRecentStoreDataProgress', label: 'store data' },
  { key: 'SyncBestSellingProgress', label: 'best selling' },
  { key: 'SyncMerchandiseProgress', label: 'mechandising' },
  { key: 'SyncMultipleLanguageProgress', label: 'multiple language' },
  { key: 'SyncSuggestionTermProgress', label: 'suggestion' },
  { key: 'SyncStampedReviewProgress', label: 'Stamped review' },
  { key: 'SyncYotpoReviewProgress', label: 'Yotpo review' }
];

export const SYNC_TYPE_FLOW_MANUAL_SYNC = 'FlowManualSync';
export const SYNC_TYPE_FLOW_MULTIPLE_LANGUAGE = 'FlowMultipleLanguage';
export const SYNC_TYPE_FLOW_MULTIPLE_CURRENCIES = 'FlowMultipleCurrencies';
export const SYNC_TYPE_FLOW_PRODUCT_CUSTOM_HTML = 'FlowProductCustomHTML';
export const SYNC_TYPE_FLOW_BEST_SELLING = 'FlowBestSelling';
export const SYNC_TYPE_FLOW_SUB_FLOW = 'SubFlow';
export const SYNC_TYPE_INSTALL = 'FlowInstallSync';

export const SYNC_LIST = {
  [SYNC_TYPE_FLOW_MANUAL_SYNC]: 'AdminHTML.Sync.Constants.flowManualSync_Title',
  [SYNC_TYPE_FLOW_MULTIPLE_LANGUAGE]: 'AdminHTML.Sync.Constants.flowMultipleLanguage_Title',
  [SYNC_TYPE_FLOW_MULTIPLE_CURRENCIES]: 'AdminHTML.Sync.Constants.FlowMultipleCurrencies_Title',
  [SYNC_TYPE_FLOW_PRODUCT_CUSTOM_HTML]: 'AdminHTML.Sync.Constants.flowProductCustomHTML_Title',
  [SYNC_TYPE_FLOW_BEST_SELLING]: 'AdminHTML.Sync.Constants.flowBestSelling_Title'
};

export function getSyncContent(syncType, i18n) {
  switch (syncType) {
    case SYNC_TYPE_FLOW_MANUAL_SYNC:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.flowManualSync_Name'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.flowManualSync_Name'),
        textContent: i18n.translate('AdminHTML.Sync.Constants.flowManualSync_TextContent'),
        title: i18n.translate('AdminHTML.Sync.Constants.flowManualSync_Title'),
        description: (
          <span>{i18n.translate('AdminHTML.Sync.Constants.flowManualSync_Description')}</span>
        ),
        completeText: ''
      };
    case SYNC_TYPE_FLOW_MULTIPLE_LANGUAGE:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_Name'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_TextTitle'),
        textContent: i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_TextContent'),
        title: i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_Title'),
        description: (
          <span>
            {i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_Description', {
              t1: (
                <b>
                  {i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_Description_t1')}
                </b>
              )
            })}
          </span>
        ),
        completeText: i18n.translate('AdminHTML.Sync.Constants.flowMultipleLanguage_CompleteText')
      };
    case SYNC_TYPE_FLOW_MULTIPLE_CURRENCIES:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_Name'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_TextTitle'),
        textContent: i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_TextContent'),
        title: i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_Title'),
        description: (
          <span>
            {i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_Description', {
              t1: (
                <b>
                  {i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_Description_t1')}
                </b>
              )
            })}
          </span>
        ),
        completeText: i18n.translate('AdminHTML.Sync.Constants.FlowMultipleCurrencies_CompleteText')
      };
    case SYNC_TYPE_FLOW_PRODUCT_CUSTOM_HTML:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_Name'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_TextTitle'),
        textContent: i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_TextContent'),
        title: i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_Title'),
        description: (
          <span>
            {i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_Description')}
          </span>
        ),
        completeText: i18n.translate('AdminHTML.Sync.Constants.flowProductCustomHTML_CompleteText')
      };
    case SYNC_TYPE_FLOW_BEST_SELLING:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_Name'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_TextTitle'),
        textContent: i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_TextContent'),
        title: i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_Title'),
        description: (
          <span>
            {i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_Description', {
              t1: (
                <Link external url={URL.SyncDocBoostAllCollection}>
                  {i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_Description_t1')}
                </Link>
              )
            })}
          </span>
        ),
        completeText: i18n.translate('AdminHTML.Sync.Constants.flowBestSelling_CompleteText')
      };
    case SYNC_TYPE_INSTALL:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.manualSync_Title'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.manualSync_Title'),
        textContent: '',
        title: i18n.translate('AdminHTML.Sync.Constants.manualSync_Title'),
        description: <span></span>,
        completeText: ''
      };
    default:
      return {
        name: i18n.translate('AdminHTML.Sync.Constants.autoSync_Title'),
        textTitle: i18n.translate('AdminHTML.Sync.Constants.autoSync_Title'),
        textContent: '',
        title: i18n.translate('AdminHTML.Sync.Constants.autoSync_Title'),
        description: <span></span>,
        completeText: ''
      };
  }
}

export const NUMBER_SYNC_PER_PAGE = 10;

export const SYNC_TRIGGER_TYPE = [
  'All', // All
  'ManualSync',
  'AutoSync',
  'ScheduledSync'
];

export const SYNC_TRIGGER_TYPE_LABEL = {
  All: 'AdminHTML.Sync.Constants.allSync_Title',
  ManualSync: 'AdminHTML.Sync.Constants.manualSync_Title',
  AutoSync: 'AdminHTML.Sync.Constants.autoSync_Title',
  ScheduledSync: 'AdminHTML.Sync.Constants.scheduleSync_Title'
};
